import { Button, Divider, InputLabel, TextField } from "@mui/material";
import { ApiRequest } from "GlobalFunctions";
import { useState } from "react";
import { useSnackbar } from 'notistack';

export default function ForgotPassword(props: any) {


    const { enqueueSnackbar } = useSnackbar();

    const [email, setEmail] = useState('');
    const [showToast, setShowToast] = useState(false);


    const handleSubmit = async () => {
        

        // Validate email
        if (!email.trim()) {
            enqueueSnackbar('Please enter your email address', { variant: 'error' });
            return;
        }

        // Simple email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            enqueueSnackbar('Invalid email address', { variant: 'error' });
            return;
        }

        // Show toast before making API call
        setShowToast(true);

        await ApiRequest({
            url: '/users/send_password_reset_email',
            method: 'POST',
            body: {
                email
            },
            setResponse: (response: any) => {
                // API response received
            }
        });
    };

    return (
        <div className="forgot_password_container">

            <div>
                <h2>Forgot Password</h2>
                <p>Enter the email associated with your account, and we’ll send you a link to reset your password.</p>
                <Divider style={{ margin: '20px 0', borderColor: '#ECEBFF' }} />


                {!showToast &&
                    <div className="textfield_wrapper">
                        <InputLabel className="login_label">Email</InputLabel>
                        <TextField
                            variant="outlined"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                        />
                    </div>
                }
                {showToast &&
                    <div className="reset-toast-container">
                        If an account exists for the email you entered, you'll be sent a password reset link. Please check your inbox and spam folder.
                    </div>
                }
            </div>

            
            {!showToast &&
                <a className="forgot_password_link" href="/login" >
                    Wait, I remember my password
                </a>
            }


            <Button
                variant="contained"
                color="primary"
                className="forgot_password_button"
                onClick={() => {
                    if (showToast) {
                        // If toast is shown, redirect to login
                        window.location.href = '/login';
                    } else {
                        // If toast is not shown, submit form
                        handleSubmit();
                    }
                }}
            >
                {showToast ? 'Back to Login' : 'Send Reset Instructions'}
            </Button>
        </div>
    )
}